<template>
    <div>
        <div v-if="questionList.length" :class="wrapperClass">
            <el-card v-for="(item, index) in questionList"
                     class="pointer"
                     style="border-radius: 14px"
                     @click.native.stop="handleCardClick(item, index)"
                     :key="`question-${item.Id}`"
                     :body-style="{
                                       padding: '0 0 30px 0',
                                       position: 'relative'
                                 }">
                <img src="@/assets/img/psq/personCenter/questionnaire-bg.png"
                     alt="questionnaire"
                     class="questionnaire-bg"/>
                <div class="questionnaire-status" :class="getStatusClass(item.State)">
                    {{ QUESTION_STATUS_USER[item.State] }}
                </div>
                <div class="questionnaire-title">{{ item.Name }}</div>
                <div class="questionnaire-time">问卷时间：{{ item.QuestionnaireStartTime }} -
                    {{ item.QuestionnaireEndTime }}
                </div>
            </el-card>
        </div>
        <div class="no-data" v-else>
            <img src="@/assets/img/psq/personCenter/no-data.png" alt="noData"/>
            <div class="font-size16" style="margin-top: 30px">暂无问卷</div>
        </div>
    </div>
</template>
<script>
import { QUESTION_STATUS_USER } from "@/utils/question-config"

export default {
    name: "QuestionCard",
    data() {
        return {
            QUESTION_STATUS_USER
        }
    },
    props: {
        questionList: {
            type: Array,
            default() {
                return []
            },
            required: true
        },
        wrapperClass: {}
    },
    methods: {
        handleCardClick(item, index) {
            this.$emit("onCardClick", item, index)
        },
        getStatusClass(status) {
            const statusMap = {
                0: "is--no-start",
                1: "is--progress",
                2: "is--do",
                3: "is--end"
            }
            return statusMap[status]
        },
    }
}
</script>

<style scoped lang="less">
.questionnaire-bg {
    width: 100%;
}

.questionnaire-status {
    position: absolute;
    top: 29px;
    left: 0;
    padding: 8px 16px;
    border-radius: 0 16px 16px 0;
    color: #fff;

    &.is--progress {
        background-color: #2EE4AD;
    }

    &.is--end {
        background-color: #BABFCB;
    }

    &.is--no-start {
        background-color: #BABFCB;
    }

    &.is--do {
        background-color: #BABFCB;
    }
}

.questionnaire-title {
    font-size: 16px;
    padding: 30px;
    font-weight: 500;
}

.questionnaire-time {
    padding: 0 30px;
    font-size: 13px;
    color: #72777F;
}

.no-data {
    width: 100%;
    height: calc(100% - 100px);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

</style>
